import { render, staticRenderFns } from "./AbsenceRequestPage.vue?vue&type=template&id=5376c05a&"
import script from "./AbsenceRequestPage.vue?vue&type=script&lang=js&"
export * from "./AbsenceRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports